import { render } from "./ScannerView.vue?vue&type=template&id=55dc1986"
import script from "./ScannerView.vue?vue&type=script&lang=js"
export * from "./ScannerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__